export default __webpack_public_path__ + "static/fall13-c80f9fe6db4ef677b7d110d3a1a9438a.webp";